import { render } from "./OwnerAddDialog.vue?vue&type=template&id=2fcb7d46"
import script from "./OwnerAddDialog.vue?vue&type=script&lang=js"
export * from "./OwnerAddDialog.vue?vue&type=script&lang=js"

import "./OwnerAddDialog.vue?vue&type=style&index=0&id=2fcb7d46&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__